/**
 * 资产平台通用接口
 */
import { Api as FetchAPI } from '@/utils';

export async function getPage({
  namespace = 'asset',
  moduleCode = '',
  condition = '',
  pageNum = 1,
  pageSize = 10,
  parameters = {},
} = {}) {
  const res = await FetchAPI({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${namespace}/${moduleCode}/page`,
    data: {
      condition,
      pageNum,
      pageSize,
      parameters,
    },
  });
  return res[1]?.data;
}

export async function getModule(moduleCodes: string[]) {
  const res = await FetchAPI({
    method: 'post',
    url: `/api/gateway/metabase/compose/modules`,
    data: moduleCodes,
  });
  return res[1]?.data;
}
